export enum LorenImageSize {
    ORIGINAL = 'original',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large'
}
